export const ProposalStatusMap = {
  Waiting: 'waiting',
  Accepted: 'accepted',
  Rejected: 'rejected',
}

export const ProposalStatusLabelMap = {
  [ProposalStatusMap.Waiting]: '대기중',
  [ProposalStatusMap.Accepted]: '제안수락',
  [ProposalStatusMap.Rejected]: '제안거절',
} as const
